import { Component, Input } from '@angular/core';

import { AppContext } from './../../shared';

@Component({
  selector: 'upgrade-message',
  template: require('./upgrade-message.component.html'),
  styles: [require('./upgrade-message.component.scss')]
})

export class UpgradeMessageComponent {
  @Input() title: string;
  @Input() content: string;

  constructor(private app: AppContext) {
    // Do stuff
  }

  close() {
    this.app.hideUpgrade();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/message/upgrade-message/upgrade-message.component.ts